module.exports = __webpack_public_path__ + "img/lancome_answer_correct.ff47dcbc.svg";